(function () {
  const TARGET_ID = 'shopify-section-template--20692721336576__section_Uqz43Y';
  const CLEAN_HASH = '#services';   // what you want to show in the URL
  const OFFSET = 100;               // adjust for sticky header height
  const MENU_CLOSE_DELAY = 200;     // wait for mobile menu to close

  function getAnchorFromEvent(e) {
    if (typeof e.composedPath === 'function') {
      for (const el of e.composedPath()) if (el && el.tagName === 'A') return el;
    }
    return e.target.closest && e.target.closest('a');
  }

  function scrollToTarget() {
    const el = document.getElementById(TARGET_ID);
    if (!el) return;
    const top = el.getBoundingClientRect().top + window.pageYOffset - OFFSET;
    try { window.scrollTo({ top, behavior: 'smooth' }); } catch { window.scrollTo(0, top); }
  }

  // Intercept "Services" clicks (even inside shadow DOM)
  window.addEventListener('click', function (e) {
    const a = getAnchorFromEvent(e);
    if (!a) return;
    if ((a.textContent || '').trim().toLowerCase() !== 'services') return;

    e.preventDefault();

    // If on home, scroll and show clean /#services
    if (location.pathname === '/' || location.pathname === '/index.html') {
      setTimeout(function () {
        scrollToTarget();
        // Show clean hash in URL bar without reload
        history.replaceState(null, '', '/' + CLEAN_HASH);
      }, MENU_CLOSE_DELAY);
    } else {
      // From other pages, navigate to home with clean hash
      location.href = '/' + CLEAN_HASH;
    }
  }, true); // capture

  // If we land on /#services, auto-scroll to the real long ID
  if (location.hash === CLEAN_HASH) {
    window.addEventListener('load', function () {
      setTimeout(scrollToTarget, MENU_CLOSE_DELAY);
    });
  }
})();